module.exports = __webpack_public_path__ + "img/password_change_filled.8c886649.svg";